const Toggle = ({
  label,
  selected,
  className,
  onClick
}: {
  label: string;
  selected: boolean;
  className: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={
      "w-full py-[7px] transition " +
      (selected ? "bg-ctb-blue-400 " : "bg-ctb-grey-700 ") +
      className
    }
  >
    {label}
  </button>
);

const InlineTabSelector = <T extends string | number>({
  value,
  tabs,
  className,
  toggle,
  onChange
}: {
  value?: T;
  tabs: T[];
  className?: string;
  toggle?: boolean;
  onChange: (value: T | undefined) => void;
}) => {
  return (
    <div
      className={
        "flex flex-grow gap-[2px] text-sm font-medium leading-[150%] text-white " +
        className
      }
    >
      {tabs.map((tab, index) => (
        <Toggle
          key={index}
          label={tab.toString()}
          selected={tab === value}
          onClick={() => {
            if (toggle) {
              onChange(value === tab ? undefined : tab);
            } else {
              onChange(tab);
            }
          }}
          className={
            index === 0
              ? "rounded-s-[10px]"
              : index === tabs.length - 1
              ? "rounded-e-[10px]"
              : ""
          }
        />
      ))}
    </div>
  );
};

export default InlineTabSelector;
